import type { PricingQuoteResponse, ProductCard } from "@itaas/pep-contracts";
import type { PepLocale } from "../../i18n/types";
import { INVOICE_HD_CONFIG } from "./invoice-detail-content";
import { ProductDetailHdPage } from "./ProductDetailHdPage";

export interface InvoiceProductDetailHdProps {
  locale: PepLocale;
  product: ProductCard & { complementary?: ProductCard[] };
  prices: Record<string, PricingQuoteResponse>;
  description: string;
  showDemo: boolean;
  showTrial: boolean;
}

/** Invoice HD page — shared ProductDetailHdPage + Invoice content/assets (slug `billing`). */
export function InvoiceProductDetailHd(props: InvoiceProductDetailHdProps) {
  return <ProductDetailHdPage {...props} config={INVOICE_HD_CONFIG} />;
}
